/* Types */
import { Success } from '@/api/results'

type ExtractType<T> = T extends Success<infer D> ? D : never

export function checkResultApiRequest<T>(result: T) {
  if (result instanceof Success) {
    return result.data as ExtractType<T>
  }

  return null
}
